"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var headerReset = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map(function (tag) {
  return "& ".concat(tag);
}).join(' ,');
var useStyles = function useStyles(_ref) {
  var customWidth = _ref.customWidth;
  return (0, _styles.makeStyles)(function (theme) {
    var _header;
    return {
      tooltip: _defineProperty({
        fontSize: theme.typography.pxToRem(12),
        width: customWidth,
        minWidth: theme.spacing(30),
        maxWidth: theme.spacing(60),
        borderLeft: "8px solid ".concat(theme.palette.PURPLE300),
        color: theme.palette.NEUTRAL900,
        boxShadow: '0px 0px 1px rgba(9, 30, 66, 0.31), 0px 12px 24px rgba(9, 30, 66, 0.25)',
        borderRadius: '8px',
        padding: theme.spacing(2, 3, 2, 2),
        backgroundColor: theme.palette.NEUTRAL000
      }, headerReset, {
        fontWeight: 700,
        fontSize: theme.typography.pxToRem(12)
      }),
      content: {
        display: 'box',
        boxOrient: 'vertical',
        lineClamp: 7,
        overflow: 'hidden',
        lineHeight: theme.typography.pxToRem(20),
        fontWeight: 400,
        '& p': {
          margin: 0
        }
      },
      header: (_header = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        marginTop: 0,
        marginBottom: theme.spacing(1.5)
      }, _defineProperty(_header, headerReset, {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        margin: 0
      }), _defineProperty(_header, '& span', {
        margin: theme.spacing(0, 0, 1, 0)
      }), _defineProperty(_header, '& svg', {
        color: theme.palette.RED400,
        paddingRight: theme.spacing(0.5),
        fontSize: theme.typography.pxToRem(15)
      }), _header),
      footer: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: theme.spacing(1.5),
        '& a': {
          alignSelf: 'flex-end',
          fontWeight: 700,
          textDecoration: 'none',
          fontSize: theme.typography.pxToRem(12),
          lineHeight: theme.typography.pxToRem(20),
          color: theme.palette.BLUE400,
          marginRight: 0
        }
      },
      helpIconBtn: {
        padding: 0,
        transition: 'color 0.2s ease',
        color: theme.palette.PURPLE300,
        '&:hover, &:focus': {
          color: theme.palette.PURPLE500
        }
      },
      helpIcon: {
        cursor: 'pointer',
        fontSize: theme.typography.pxToRem(24)
      },
      helpIconActive: {
        color: theme.palette.PURPLE500
      },
      smallIcon: {
        fontSize: theme.typography.pxToRem(16)
      }
    };
  })();
};
var _default = useStyles;
exports.default = _default;